import { render, staticRenderFns } from "./hearder.vue?vue&type=template&id=64915404&"
import script from "./hearder.vue?vue&type=script&lang=js&"
export * from "./hearder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports